/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { savedOrderDetailsAddressModalStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsAddressModal";
import { addressTitleStyle } from "@monsma/App/WidgetExtensions/Addresses/SharedAddressesComponentsStylesExtension";
import { css } from "styled-components";

savedOrderDetailsAddressModalStyles.modal = {
    sizeVariant: "medium",
};

savedOrderDetailsAddressModalStyles.orderCustomerInformationGridContainer = {
    gap: 15,
    css: css`
        padding-left: 23px;
        margin: 20px 0 30px 0;
    `,
};

savedOrderDetailsAddressModalStyles.sessionCustomerInformationGridContainer = {
    gap: 15,
    css: css`
        padding-left: 23px;
        margin-top: 20px;
    `,
};

savedOrderDetailsAddressModalStyles.orderShippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

savedOrderDetailsAddressModalStyles.orderBillingInformationGridItem =
    savedOrderDetailsAddressModalStyles.orderShippingInformationGridItem;

savedOrderDetailsAddressModalStyles.sessionShippingInformationGridItem =
    savedOrderDetailsAddressModalStyles.orderShippingInformationGridItem;

savedOrderDetailsAddressModalStyles.sessionBillingInformationGridItem =
    savedOrderDetailsAddressModalStyles.orderShippingInformationGridItem;

savedOrderDetailsAddressModalStyles.orderShippingAddressTitle = addressTitleStyle;

savedOrderDetailsAddressModalStyles.orderBillingAddressTitle = addressTitleStyle;

savedOrderDetailsAddressModalStyles.sessionAddressSelectText =
    savedOrderDetailsAddressModalStyles.orderAddressSelectText;
